module.exports = __webpack_public_path__ + "img/logo.5550336c.svg";